<div class="notification">
  <h2
    class="notification__headline">
    {{'RETURN_PAGE.NOTIFICATION.INFO_COPIED' | translate}}
  </h2>
  <p
    class="notification__description">
    {{'RETURN_PAGE.NOTIFICATION.DETAIL_PAYMENT_COPIED' | translate}}
  </p>
</div>

